import { FC } from 'react';
import { Spacer } from 'internalLibrary';
import { useTranslation } from 'react-i18next';
import AdditionalInformationItem from './AdditionalInformationItem';
import classes from 'classnames';
import styles from './AdditionalInformation.module.scss';

export const AdditionalInformation: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes(styles.container)}>
      <Spacer>
        <AdditionalInformationItem
          title={t('additionalInfo1_title')}
          text={t('additionalInfo1_text')}
        />
      </Spacer>
      <Spacer marginTop="10px">
        <AdditionalInformationItem
          title={t('additionalInfo2_title')}
          text={t('additionalInfo2_text')}
        />
      </Spacer>
    </div>
  );
};
